import { onMounted, onUnmounted, ref } from "vue";

export function useAnchorShow() {
  const anchorShow = ref(false);

  const StartElement = ref<HTMLElement | null>(null);
  const EndElement = ref<HTMLElement | null>(null);
  const initElement = () => {
    StartElement.value = document.getElementById("anchor-start");
    EndElement.value = document.getElementById("anchor-end");
  };

  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    if (
      scrollTop >= (StartElement.value?.offsetTop || 0) &&
      scrollTop <= (EndElement.value?.offsetTop || document.documentElement.scrollHeight)
    ) {
      anchorShow.value = true;
    } else {
      anchorShow.value = false;
    }
  };

  onMounted(() => {
    initElement();
    window.addEventListener("scroll", handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return {
    anchorShow,
  };
}
